import React, { useState } from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
let sequence = 0;
const HelpTip = ({ label, children }) => {
  const [id] = useState(() => `rate-shop-help-${++sequence}`);
  return (
    <OverlayTrigger
      placement="auto"
      trigger={['hover', 'focus']}
      overlay={
        <Popover id={id}>
          <Popover.Header as="h3">{label}</Popover.Header>
          <Popover.Body>{children}</Popover.Body>
        </Popover>
      }
    >
      <Button
        type="button"
        variant="link"
        className="p-0 ms-2 text-muted"
        aria-label={`Help: ${label}`}
        onClick={event => event.stopPropagation()}
      >
        <FontAwesomeIcon icon={faInfoCircle} />
      </Button>
    </OverlayTrigger>
  );
};
export default HelpTip;
